module.exports = __webpack_public_path__ + "img/1723012227832-WhatsApp Image 2024-08-01 at 18.58.55.jpeg.b6ae54d0.webp";